import { render } from "./BroadcastCardWidget.vue?vue&type=template&id=07306634&scoped=true"
import script from "./BroadcastCardWidget.vue?vue&type=script&lang=js"
export * from "./BroadcastCardWidget.vue?vue&type=script&lang=js"

import "./BroadcastCardWidget.vue?vue&type=style&index=0&id=07306634&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07306634"]])

export default __exports__